export default { "backEndUrl": 'https://api.curapp.org/', "devEnvironment": false }